import useSearchFlows from '../hooks/useSearchFlows';

function useSearchFlowsInteraction(payload: { term: string }) {
  const { data, status } = useSearchFlows(payload);

  return { rows: data?.rows, status };
}

export default useSearchFlowsInteraction;
